import { createAsyncThunk } from '@reduxjs/toolkit';
import { ToppingsCategoryItem } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  FindToppingsCategoryItem,
  GetToppingsCategoryItem,
} from '../../toppingsCategoryItem/api/interface';

export const findSelectToppingsCategoryItem = createAsyncThunk(
  'selectToppingsCategoryItem/findSelectToppingsCategoryItem',
  async (values: FindToppingsCategoryItem, { rejectWithValue }) => {
    try {
      const response = await ToppingsCategoryItem.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectToppingsCategoryItem = createAsyncThunk(
  'selectToppingsCategoryItem/searchSelectToppingsCategoryItem',
  async (values: FindToppingsCategoryItem, { rejectWithValue }) => {
    try {
      const response = await ToppingsCategoryItem.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getSelectToppingsCategoryItem = createAsyncThunk(
  'selectToppingsCategoryItem/getSelectToppingsCategoryItem',
  async ({ id }: GetToppingsCategoryItem, { rejectWithValue }) => {
    try {
      const response = await ToppingsCategoryItem.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
